import { ClipCreator } from "./ClipCreator";
import { ExportNamingMode, ExportNamingModeType } from "./ExportNamingMode";
import { VariableReplacer, Variables } from "../../../../../../library-js/text/replacing/VariableReplacer";
import { RegExpUtility } from "../../../../../../library-js/text/RegExpUtility";
import { MathX } from "../../../../../../library-js/math/MathX";
import { MidiKey } from "../../../../../../library-js/audio/midi/MidiKey";
import { MusicNote } from "../../../../../../library-js/audio/music/MusicNote";
import { AudioMath } from "../../../../../../library-js/audio/AudioMath";

export class Namer
{
  exporter:ClipCreator;

  async nameExports():Promise<void>
  {
    let mode = this.exporter.settings.naming.mode.value;
    console.log( "Naming exports", ExportNamingModeType[ mode ] );

    if ( mode === ExportNamingModeType.SamplesExport )
    {
      this.exportForSamples();

    }
    else if ( mode === ExportNamingModeType.InstrumentExport )
    {
      this.exportForInstruments();
    }    
  
  }

  exportForSamples()
  {    
    let name =     this.exporter.settings.naming.exportName;
    let formula =  this.exporter.settings.naming.samplesExport.namingFormula;
    let numClips = this.exporter.settings.exports + "";
    let clipSize = this.exporter.settings.exports.size;

    let variables:Variables = { name, numClips };
    formula = VariableReplacer.replace( formula, variables );

    let zeroLength = Math.floor( MathX.log( clipSize, 10 ) + 1); 
    

    for ( let i = 0; i < this.exporter.settings.exports.size; i++ )
    {
      let clip = this.exporter.settings.exports.get( i );

      variables.index = RegExpUtility.prependZeros( i + 1 + "", zeroLength );
      variables.zIndex = i + "";

      clip.clipName = VariableReplacer.replace( formula, variables )
    }
    
  }

  exportForInstruments()
  {
    let name =     this.exporter.settings.naming.exportName;     

    let instrumentExport = this.exporter.settings.naming.instrumentExport;

    let formula =  instrumentExport.namingFormula;
    let clipSize = this.exporter.settings.exports.size;
    let variables:Variables = { name };
    formula = VariableReplacer.replace( formula, variables );

    let startNote = instrumentExport.startNote;

    let extendToLower  = instrumentExport.extendToLower.enabled;
    let extendToHigher = instrumentExport.extendToHigher.enabled;

    let lowestNote  = startNote;
    let highestNote = startNote.moveSemitones( this.exporter.settings.exports.size );

    if ( extendToLower )
    {
      lowestNote = instrumentExport.extendToLower.note;
    }

    if ( extendToHigher )
    {
      highestNote = instrumentExport.extendToHigher.note;
    }

    let zeroLength = Math.floor( MathX.log( clipSize, 10 ) + 1); 

    for ( let i = 0; i < this.exporter.settings.exports.size; i++ )
    {
      let clip = this.exporter.settings.exports.get( i );

      let rootNote = startNote.moveSemitones( i );

      let minNote = rootNote;
      let maxNote = rootNote;

      if ( i === 0 && extendToLower )
      {
        minNote = AudioMath.minNote( lowestNote, minNote );
      }

      if ( i === ( this.exporter.settings.exports.size - 1 ) && extendToHigher )
      {
        maxNote = AudioMath.maxNote( highestNote, maxNote );
      }

      console.log( i, startNote, rootNote, minNote, maxNote );

      variables.index = RegExpUtility.prependZeros( i + 1 + "", zeroLength );
      variables.zIndex = i + "";
      variables.root = rootNote.toString().toUpperCase();
      variables.min  = minNote.toString().toUpperCase();
      variables.max  = maxNote.toString().toUpperCase();;

      clip.clipName = VariableReplacer.replace( formula, variables )
    }
    
  }
}